import { useDropdownContext } from '~/components/Dropdown/hooks/useDropdownContext';
import { cn } from '~/lib/cn';

import { useItemEventHandlers } from '../../hooks/useItemEventHandlers';
import { DropdownItem } from '../DropdownItem';

type DropdownContentProps = {
  children?: React.ReactNode;
};

export function DropdownContent({ children }: DropdownContentProps) {
  const { collection, selected, multiselect, isSelected, maxSelectedOptions } =
    useDropdownContext();
  const createHandlers = useItemEventHandlers();

  const canSelectMore =
    !multiselect ||
    maxSelectedOptions === undefined ||
    selected.length < maxSelectedOptions;

  return (
    <div
      role="listbox"
      onWheel={(e) => e.stopPropagation()}
      className={cn([
        'rounded-xs',
        'bg-level-01/full',
        'w-[var(--radix-popover-trigger-width)]',
        'max-h-[20rem]',
        'mt-xs',
        'overflow-auto',
        'shadow',
        'border',
        'border-emphasis-strong',
      ])}
    >
      {children}
      {collection.map(({ label, value, ref }) => (
        <DropdownItem
          key={value}
          checked={isSelected(value)}
          isCheckbox={multiselect}
          disabled={canSelectMore ? false : !isSelected(value)}
          {...createHandlers(value)}
          ref={ref}
        >
          {label}
        </DropdownItem>
      ))}
    </div>
  );
}

DropdownContent.displayName = 'DropdownContent';
